export const technologyCategory = {
  PLATFORMS: 'Platforms',
  LANGUAGES_FRAMEWORKS: 'Languages and frameworks',
  TOOLS: 'Tools',
  TECHNIQUES: 'Techniques'
};
